import LoginPage from './login/LoginPage.vue';
import RegistrationPage from './registration/RegistrationPage.vue';
// import WelcomePage from './welcome/WelcomePage.vue';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta: {
      title: 'Connexion - Kingrecharges',
      requiresAuth: false
    }
  },
  {
    path: '/register',
    name: 'register',
    component: RegistrationPage,
    meta: {
      title: 'Inscription - Kingrecharges',
      requiresAuth: false
    }
  }
];

export default routes;
